// src/pages/Legal/TermsPage.js
import React from 'react';
import { Container, Typography, Paper, Box, Divider } from '@mui/material';
import { useTheme, useMediaQuery } from '@mui/material';

const RENGIGS = {
  green: '#2E7D32',
  lightGreen: '#4CAF50',
  lime: '#CDDC39',
  dark: '#1A2A3A',
  light: '#F8FAFC',
  border: '#E1E9F0',
  gradient: 'linear-gradient(135deg, #2E7D32 0%, #4CAF50 40%, #8BC34A 70%, #CDDC39 100%)',
};

const TermsPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Container maxWidth="lg" sx={{ py: 6 }}>
      <Paper elevation={0} sx={{ p: { xs: 3, md: 5 }, borderRadius: 3, border: `1px solid ${RENGIGS.border}` }}>
        <Typography variant="h3" sx={{ fontWeight: 900, color: RENGIGS.dark, mb: 1 }}>
          Terms of Service
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
          Effective date: April 19, 2026
        </Typography>
        <Divider sx={{ mb: 4 }} />

        <Typography variant="h5" sx={{ fontWeight: 800, color: RENGIGS.green, mb: 2 }}>1. Acceptance of Terms</Typography>
        <Typography variant="body1" paragraph>
          By accessing or using Rengigs (the "Platform"), you agree to be bound by these Terms of Service ("Terms"). If you do not agree, please do not use the Platform.
        </Typography>

        <Typography variant="h5" sx={{ fontWeight: 800, color: RENGIGS.green, mb: 2 }}>2. Description of Service</Typography>
        <Typography variant="body1" paragraph>
          Rengigs connects organizations with suppliers/vendors. Organizations may post problems; suppliers may list solutions. Users may interact, bid, and subscribe to premium features.
        </Typography>

        <Typography variant="h5" sx={{ fontWeight: 800, color: RENGIGS.green, mb: 2 }}>3. User Accounts</Typography>
        <Typography variant="body1" paragraph>
          You must provide accurate information and keep your credentials secure. You are responsible for all activity under your account. Notify us immediately of any unauthorized use.
        </Typography>

        <Typography variant="h5" sx={{ fontWeight: 800, color: RENGIGS.green, mb: 2 }}>4. User Conduct</Typography>
        <Typography variant="body1" paragraph>
          You agree not to: (a) violate any laws; (b) infringe intellectual property; (c) post harmful or fraudulent content; (d) interfere with the Platform's operation; (e) scrape or harvest data without permission.
        </Typography>

        <Typography variant="h5" sx={{ fontWeight: 800, color: RENGIGS.green, mb: 2 }}>5. Payments and Subscriptions</Typography>
        <Typography variant="body1" paragraph>
          Premium features require a paid subscription. All payments are processed by Stripe. Subscriptions automatically renew unless cancelled. Fees are non-refundable except as required by law.
        </Typography>

        <Typography variant="h5" sx={{ fontWeight: 800, color: RENGIGS.green, mb: 2 }}>6. Intellectual Property</Typography>
        <Typography variant="body1" paragraph>
          The Platform and its content (excluding user submissions) are owned by Rengigs. You may not copy, modify, or distribute without permission. Users retain ownership of their posts but grant Rengigs a license to display them.
        </Typography>

        <Typography variant="h5" sx={{ fontWeight: 800, color: RENGIGS.green, mb: 2 }}>7. Termination</Typography>
        <Typography variant="body1" paragraph>
          We may suspend or terminate your account for violation of these Terms. You may delete your account at any time.
        </Typography>

        <Typography variant="h5" sx={{ fontWeight: 800, color: RENGIGS.green, mb: 2 }}>8. Disclaimer of Warranties</Typography>
        <Typography variant="body1" paragraph>
          The Platform is provided "as is" without warranties of merchantability, fitness for a particular purpose, or non‑infringement. We do not guarantee that the Platform will be uninterrupted or error‑free.
        </Typography>

        <Typography variant="h5" sx={{ fontWeight: 800, color: RENGIGS.green, mb: 2 }}>9. Limitation of Liability</Typography>
        <Typography variant="body1" paragraph>
          To the maximum extent permitted by law, Rengigs shall not be liable for any indirect, incidental, or consequential damages arising from your use of the Platform.
        </Typography>

        <Typography variant="h5" sx={{ fontWeight: 800, color: RENGIGS.green, mb: 2 }}>10. Governing Law</Typography>
        <Typography variant="body1" paragraph>
          These Terms shall be governed by the laws of The Federal Republic of Nigeria, without regard to conflict of law principles.
        </Typography>

        <Typography variant="h5" sx={{ fontWeight: 800, color: RENGIGS.green, mb: 2 }}>11. Changes to Terms</Typography>
        <Typography variant="body1" paragraph>
          We may update these Terms from time to time. Continued use after changes constitutes acceptance.
        </Typography>

        <Typography variant="body2" sx={{ mt: 4, color: 'text.secondary' }}>
          For questions, contact us at legal@rengigs.com.
        </Typography>
      </Paper>
    </Container>
  );
};

export default TermsPage;